import { createAction } from 'typesafe-actions';
import { WishlistItem, WishlistItemFlow } from '../types';

export const WISHLIST_RESET = createAction('basket/WISHLIST_RESET')();
export const WISHLIST_UPDATE_ITEM = createAction('basket/WISHLIST_UPDATE_ITEM')<WishlistItem>();
export const WISHLIST_SET = createAction('basket/WISHLIST_SET')<WishlistItem[]>();
export const WISHLIST_ITEM_FLOW = createAction('basket/WISHLIST_ITEM_FLOW')<WishlistItemFlow>();
